import React from 'react'
import { func, string, object, bool } from 'prop-types'

const Overlay = ({
  closeDialog = () => {},
  className = '',
  style = {},
  shouldRender = true
}) => {
  return shouldRender ? (
    <div
      className={`overlay ${className}`}
      {...{ style }}
      onClick={closeDialog}
    />
  ) : null
}

Overlay.propTypes = {
  className: string,
  closeDialog: func,
  shouldRender: bool,
  style: object
}

export default Overlay
